import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"
import _imports_0 from '@/assets/img/icon/deleteFilledAntDesignRed.svg'


const _hoisted_1 = { class: "type-bus-form flex-col flex relative h-full px-3" }
const _hoisted_2 = { class: "title-form py-5 mb-6 flex items-center justify-between" }
const _hoisted_3 = { class: "font-bold" }
const _hoisted_4 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "w-3 h-3",
  alt: "delete"
}, null, -1)
const _hoisted_5 = { class: "p-fluid" }
const _hoisted_6 = { class: "p-field mb-4" }
const _hoisted_7 = /*#__PURE__*/_createVNode("label", {
  for: "level",
  class: "text-body2"
}, "Level", -1)
const _hoisted_8 = {
  key: 0,
  class: "p-error"
}
const _hoisted_9 = { class: "p-field mb-4" }
const _hoisted_10 = /*#__PURE__*/_createVNode("label", {
  for: "level",
  class: "text-body2"
}, "Nama Diskon", -1)
const _hoisted_11 = {
  key: 0,
  class: "p-error"
}
const _hoisted_12 = { class: "p-field mb-4" }
const _hoisted_13 = /*#__PURE__*/_createVNode("label", {
  for: "diskon",
  class: "text-body2"
}, "Jumlah Diskon", -1)
const _hoisted_14 = { class: "p-input-icon-right mt-1 color-blue-grey" }
const _hoisted_15 = /*#__PURE__*/_createVNode("i", { class: "pi pi-percentage text-sm" }, null, -1)
const _hoisted_16 = {
  key: 0,
  class: "p-error"
}
const _hoisted_17 = { class: "p-field mb-4" }
const _hoisted_18 = /*#__PURE__*/_createVNode("label", {
  for: "level",
  class: "text-body2"
}, "Rata2 / Bulan (6 Bulan)", -1)
const _hoisted_19 = { class: "p-inputgroup mt-1" }
const _hoisted_20 = /*#__PURE__*/_createVNode("span", { class: "p-inputgroup-addon text-sm" }, "Rp", -1)
const _hoisted_21 = {
  key: 0,
  class: "p-field"
}
const _hoisted_22 = /*#__PURE__*/_createVNode("label", { for: "idActive" }, "Aktif", -1)
const _hoisted_23 = { class: "btn-action w-full mt-auto mb-5" }
const _hoisted_24 = /*#__PURE__*/_createTextVNode("Kembali")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")
  const _component_InputNumber = _resolveComponent("InputNumber")
  const _component_InputSwitch = _resolveComponent("InputSwitch")
  const _component_Button = _resolveComponent("Button")

  return (_openBlock(), _createBlock("section", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("h6", _hoisted_3, _toDisplayString(_ctx.title), 1),
      (_ctx.id !== '' && _ctx.temp.Kelas > 0)
        ? (_openBlock(), _createBlock("div", {
            key: 0,
            class: "background-red-lighten-5 p-3 rounded-md cursor-pointer",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.deleteData()))
          }, [
            _hoisted_4
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode("form", {
      id: "form-discount-company",
      onSubmit: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_ctx.submitData(!_ctx.v$.$invalid)), ["prevent"]))
    }, [
      _createVNode("div", _hoisted_5, [
        _createVNode("div", _hoisted_6, [
          _hoisted_7,
          _createVNode(_component_InputText, {
            id: "level",
            class: "input-primary mt-1 uppercase",
            name: "level",
            modelValue: _ctx.v$.level.$model,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.v$.level.$model = $event)),
            type: "number"
          }, null, 8, ["modelValue"]),
          ((_ctx.v$.level.$invalid && _ctx.submitted) || _ctx.v$.level.$pending.$response)
            ? (_openBlock(), _createBlock("small", _hoisted_8, _toDisplayString(_ctx.v$.level.required.$message), 1))
            : _createCommentVNode("", true)
        ]),
        _createVNode("div", _hoisted_9, [
          _hoisted_10,
          _createVNode(_component_InputText, {
            id: "name",
            class: "input-primary mt-1",
            name: "name",
            modelValue: _ctx.v$.name.$model,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.v$.name.$model = $event)),
            type: "text"
          }, null, 8, ["modelValue"]),
          ((_ctx.v$.name.$invalid && _ctx.submitted) || _ctx.v$.name.$pending.$response)
            ? (_openBlock(), _createBlock("small", _hoisted_11, _toDisplayString(_ctx.v$.name.required.$message), 1))
            : _createCommentVNode("", true)
        ]),
        _createVNode("div", _hoisted_12, [
          _hoisted_13,
          _createVNode("span", _hoisted_14, [
            _hoisted_15,
            _createVNode(_component_InputText, {
              type: "number",
              class: "input-primary",
              min: "-1",
              max: "100",
              modelValue: _ctx.v$.discount.$model,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.v$.discount.$model = $event))
            }, null, 8, ["modelValue"]),
            ((_ctx.v$.discount.$invalid && _ctx.submitted) || _ctx.v$.discount.$pending.$response)
              ? (_openBlock(), _createBlock("small", _hoisted_16, _toDisplayString(_ctx.v$.discount.required.$message), 1))
              : _createCommentVNode("", true)
          ])
        ]),
        _createVNode("div", _hoisted_17, [
          _hoisted_18,
          _createVNode("div", _hoisted_19, [
            _hoisted_20,
            _createVNode(_component_InputNumber, {
              modelValue: _ctx.minTransaction,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.minTransaction = $event)),
              mode: "decimal",
              class: "input-primary",
              locale: "id-ID"
            }, null, 8, ["modelValue"])
          ])
        ]),
        (_ctx.id !== '' && _ctx.temp.Kelas > 0)
          ? (_openBlock(), _createBlock("div", _hoisted_21, [
              _hoisted_22,
              _createVNode("div", null, [
                _createVNode(_component_InputSwitch, {
                  id: "idActive",
                  class: "switch-og mt-1",
                  modelValue: _ctx.isActive,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.isActive = $event))
                }, null, 8, ["modelValue"])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ], 32),
    _createVNode("div", _hoisted_23, [
      _createVNode(_component_Button, {
        label: "Simpan",
        type: "submit",
        form: "form-discount-company",
        class: "font-semibold p-button-sm btn-primary px-10 mr-2"
      }),
      _createVNode(_component_Button, {
        class: "btn-secondary text-black p-button-sm px-10 py-1",
        onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.closeSidebar()))
      }, {
        default: _withCtx(() => [
          _hoisted_24
        ]),
        _: 1
      })
    ])
  ]))
}